export function getDate() {
    let date = new Date();
    let day = String(date.getDate()).padStart(2, "0");
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let year = date.getFullYear();
    date = `${day}/${month}/${year}`;
    return date;
}

export function getHour() {
    let hours = new Date();
    let hour = hours.getHours();
    if (hour < 10) {
        hour = "0" + hour;
    }
    let minutes = hours.getMinutes();
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    let seconds = hours.getSeconds();
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    hours = `${hour}:${minutes}:${seconds}`;
    return hours;
}

export function dateDiffInDays(date1Str, date2Str) {
    let aux = date1Str.split("/");
    date1Str = `${aux[1]}/${aux[0]}/${aux[2]}`;
    aux = date2Str.split("/");
    date2Str = `${aux[1]}/${aux[0]}/${aux[2]}`;

    const date1 = new Date(date1Str);
    const date2 = new Date(date2Str);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}
